import { ESKIMO_2026_27_LAUNCH } from './eskimo-2026-27';
import { CLAM_2026_27_LAUNCH } from './clam-2026-27';
import { getLaunchPath } from '../../domain/seasonalLaunch';

export const SEASONAL_LAUNCHES = Object.freeze([ESKIMO_2026_27_LAUNCH, CLAM_2026_27_LAUNCH]);

export function getSeasonalLaunchBySlug(slug) {
  const key = String(slug || '').replace(/^\/+|\/+$/g, '');
  return SEASONAL_LAUNCHES.find((launch) => launch.slug === key) || null;
}

export function getSeasonalLaunchByPath(path) {
  const normalized = String(path || '').replace(/\/+$/, '') || '/';
  return SEASONAL_LAUNCHES.find((launch) => getLaunchPath(launch) === normalized) || null;
}

export { ESKIMO_2026_27_LAUNCH };
export { CLAM_2026_27_LAUNCH };
